import React from 'react'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'
import ProductsCollection from './partials/products-collection'
import BrandInfo from './partials/brand-info'
import BrandHero from './partials/brand-hero'
import BrandCategory from './partials/brand-category'

const BrandDetail = ({category}) => {
    return (
        <Box>
            <Box>
                <BrandHero category={category} />
            </Box>

            <Box>
                <BrandCategory category={category} />
                <ProductsCollection category={category} />
                <BrandInfo category={category} />
            </Box>
        </Box>
    )
}

BrandDetail.propTypes = {
    category: PropTypes.object
}

export default BrandDetail
